'use strict';

// Generated by CoffeeScript 1.12.7
/* global document:false, window:false, GrouponSDSCommon:false, Cookie:false */

require('./sds_common');

const GrouponSDSClass = (function() {
  const dlg_id = 'sub_dlg';

  const focus_input_id = 'email_id';

  const alt_focus_input_id = 'email';

  function GrouponSDS() {
    let ref, showContainer, showSubsUI;
    if (
      (ref = window.SubscriptionsUI) != null
        ? typeof ref._should_show_doi === 'function'
          ? ref._should_show_doi()
          : void 0
        : void 0
    ) {
      //document.getElementById('global-container').style.display = '';
      return;
    }
    if (this.shouldHideUI()) {
      //document.getElementById('global-container').style.display = '';
    } else {
      showSubsUI = (function(_this) {
        return function() {
          GrouponSDSCommon.setupSuccessCallback();
          return _this.showModal();
        };
      })(this);
      showContainer = function() {
        //document.getElementById('global-container').style.display = '';
      };
      GrouponSDSCommon.fpBasedShow(showSubsUI, showContainer);
    }
  }

  GrouponSDS.prototype.shouldHideUI = function() {
    const subForced = GrouponSDSCommon.isSubForced();
    const hideUI =
      !subForced &&
      !GrouponSDSCommon.isNAQTraffic() &&
      (GrouponSDSCommon.isEmailClickTraffic() ||
        GrouponSDSCommon.isMobileSeoSkippingTraffic());
    if (hideUI) {
      GrouponSDSCommon.log('subscriptionUINotShown', {
        uiType: 'modal-dialog',
      });
    } else if (subForced) {
      GrouponSDSCommon.log('subscriptionUIForced');
    }
    return hideUI;
  };

  GrouponSDS.prototype.showModal = function() {
    let dlg_height, dlg_width, height;
    //document.getElementById('global-container').style.display = '';
    const $container = document.getElementById('subscribe_modal_container');
    const $dlg = document.getElementById(dlg_id);
    if (!$dlg.classList.contains('centered')) {
      dlg_width = $container.getBoundingClientRect().width;
      dlg_height = $container.getBoundingClientRect().height;
      $container.style.top = '50%';
      $container.style.left = '50%';
      $container.style.height = dlg_height;
      $container.style.width = dlg_width;
      $container.style.marginTop = -dlg_height / 2;
      $container.style.marginLeft = -dlg_width / 2;
    }
    $container.style.display = '';
    if ($dlg.classList.contains('round')) {
      height = Math.round($dlg.scrollHeight);

      if (height > $dlg.getBoundingClientRect().height) {
        $dlg.style.height = `${height +
          2 *
            parseInt(
              window
                .getComputedStyle($dlg)
                .getPropertyValue('padding')
                .slice(0, -2)
            ) +
          2 *
            parseInt(
              window
                .getComputedStyle($dlg)
                .getPropertyValue('border')
                .slice(0, -2)
            )}px`;
        $dlg.style.width = `${height +
          2 *
            parseInt(
              window
                .getComputedStyle($dlg)
                .getPropertyValue('padding')
                .slice(0, -2)
            ) +
          2 *
            parseInt(
              window
                .getComputedStyle($dlg)
                .getPropertyValue('border')
                .slice(0, -2)
            )}px`;
      }
    }
    const overlayColor =
      window._subscriptionOverlayColor != null
        ? window._subscriptionOverlayColor
        : '#333';

    /*spotlightHelper.spotlight({
      opacity: 0.7,
      color: overlayColor,
      exitEvent: "none"
    }, document.getElementById('subscribe_modal_container'));*/
    document.getElementById('subscribe_modal_container').spotlight({
      opacity: 0.7,
      color: overlayColor,
      exitEvent: 'none',
    });

    if (document.getElementById(focus_input_id) !== null) {
      const focus_input_object = document.getElementById(focus_input_id);
      const event = document.createEvent('HTMLEvents');
      event.initEvent('focus', true, false);
      focus_input_object.dispatchEvent(event);
    } else if (document.getElementById(alt_focus_input_id) !== null) {
      const alt_focus_input_object = document.getElementById(
        alt_focus_input_id
      );
      const event = document.createEvent('HTMLEvents');
      event.initEvent('focus', true, false);
      alt_focus_input_object.dispatchEvent(event);
    }
    GrouponSDSCommon.gtmSubscribeLandingEvent();
    const now = new Date();
    window._subsUIshown = {
      uiType: 'modal-dialog',
      time: now.getTime(),
    };
    $dlg.addEventListener('dismiss', () => {
      GrouponSDSCommon.dismissModal(
        document.getElementById('subscribe_modal_container')
      );
      return GrouponSDSCommon.log('subscriptionUIHidden', {
        uiType: 'modal-dialog',
      });
    });
    $dlg.addEventListener('fail', () => {
      return GrouponSDSCommon.dismissModal(
        document.getElementById('subscribe_modal_container')
      );
    });
    $dlg.addEventListener('success', () => {
      let ref, ref1;
      GrouponSDSCommon.dismissModal(
        document.getElementById('subscribe_modal_container')
      );
      if (window._subscriptionSuccessCallback == null) {
        GrouponSDSCommon.showSuccessNotification();
        GrouponSDSCommon.gtmSubscribeEvent();
      }
      if (
        (ref = window.SubscriptionsUI) != null ? ref._should_show_doi() : void 0
      ) {
        return (ref1 = window.SubscriptionsUI) != null
          ? ref1._get_doi_modal_and_show('#333')
          : void 0;
      }
    });
    $dlg.addEventListener('close', () => {
      GrouponSDSCommon.dismissModal(
        document.getElementById('subscribe_modal_container')
      );
      if (typeof Cookie !== 'undefined' && Cookie !== null) {
        Cookie.set('hide_sub_modal', 1, {
          maxAge: 24 * 60 * 60 * 1000,
          domain: document.domain,
        });
      }
      GrouponSDSCommon.log('subscriptionUIHidden', {
        uiType: 'modal-dialog',
      });
    });
  };

  return GrouponSDS;
})();

function initWhenDependencies() {
  const cond = window.Cookie && window.GrouponSDSCommon;
  if (cond) {
    window.GrouponSDS = GrouponSDSClass;
    return (window.SDSinit = new GrouponSDSClass());
  }
  return setTimeout(initWhenDependencies, 250);
}

initWhenDependencies();
